export const TESTIMONIALS_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_desktop_image: "",
    meta_name: "Student Name",
    meta_name_text_color: "#000000",
    meta_designation: "Student",
    meta_designation_text_color: "#000000",
    meta_description: "Testimonial description",
    meta_description_text_color: "#000000",
    meta_alt_image: "Student",
    meta_video_url: "",
    meta_video: "",
    meta_priority: 0,
    meta_status: true,
  },

  TESTIMONIALS_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "Student Testimonials",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "card_color",
      label: "Card Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter card background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "left_navigation_icon",
      label: "Left Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Left Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "left_navigation_icon_alt",
      label: "Left Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for left navigation icon",
      required: false,
      defaultValue: "Left navigation",
    },
    {
      fieldName: "right_navigation_icon",
      label: "Right Navigation Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Right Navigation Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "right_navigation_icon_alt",
      label: "Right Navigation Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for right navigation icon",
      required: false,
      defaultValue: "Right navigation",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
      defaultValue: false,
    }
  ],

  METADATA_FIELDS: [
    {
      header: "Desktop Image",
      fieldName: "meta_desktop_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Desktop Image",
    },
    {
      header: "Name",
      fieldName: "meta_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Name",
    },
    {
      header: "Name Text Color",
      fieldName: "meta_name_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter name text color (e.g., #000000)",
    },
    {
      header: "Designation",
      fieldName: "meta_designation",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Designation",
    },
    {
      header: "Designation Text Color",
      fieldName: "meta_designation_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter designation text color (e.g., #000000)",
    },
    {
      header: "Description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
    },
    {
      header: "Description Text Color",
      fieldName: "meta_description_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description text color (e.g., #000000)",
    },
    {
      header: "Alt Image",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
    },
    {
      header: "Video URL",
      fieldName: "meta_video_url",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Video URL",
    },
    {
      header: "Video",
      fieldName: "meta_video",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Video File",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
  ]
};

